import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaMusic, FaMobileAlt, FaImages, FaMapMarkerAlt, FaUsers, FaCode, FaRocket, FaSearch, FaCalendarAlt, FaGlassCheers, FaClock, FaHeadset } from 'react-icons/fa';
import Button from '../../components/Button';

const WebDiscotecaPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-pymes", text: "Página web barata para PYMES" },
    { url: "/servicios/landing-pages", text: "Landing pages económicas" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Promociona eventos mientras trabajas",
      description: "Tu web trabaja 24/7, informando sobre próximos eventos, promociones y fiestas incluso cuando el local está cerrado. Asegura llenos totales."
    },
    {
      title: "Crea expectación con contenido visual",
      description: "El 76% de los clientes potenciales buscan ver fotos y vídeos del ambiente antes de decidir dónde salir. Muestra la mejor cara de tu local."
    },
    {
      title: "Diferénciate de la competencia",
      description: "El 62% de los locales de ocio nocturno aún no tienen una web profesional. Destaca con una presencia online atractiva que transmita el ambiente único de tu local."
    },
    {
      title: "Posiciónate localmente en Google",
      description: "Aparece cuando buscan 'discotecas en [tu zona]' o 'salir de fiesta en [tu ciudad]'. El 93% de las búsquedas de ocio nocturno incluyen términos de localización."
    },
    {
      title: "Informa sobre eventos especiales",
      description: "Promociona DJs invitados, fiestas temáticas, aniversarios y eventos especiales con anticipación. Genera expectación y asegura mayor asistencia."
    },
    {
      title: "Recupera la inversión en un solo evento",
      description: "Con solo un aumento del 10-15% en la asistencia a un evento especial gracias a la web, recuperas completamente la inversión. Después todo son beneficios."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaMusic />,
      title: "Sección de eventos y programación",
      description: "Calendario actualizable de próximos eventos, DJs, fiestas temáticas y promociones especiales. Mantén informado a tu público sobre todas las novedades."
    },
    {
      icon: <FaMobileAlt />,
      title: "Diseño 100% adaptado a móviles",
      description: "El 87% de las búsquedas de ocio nocturno se hacen desde el móvil. Tu web será perfecta en cualquier dispositivo, especialmente en teléfonos."
    },
    {
      icon: <FaImages />,
      title: "Galería multimedia impactante",
      description: "Imágenes y vídeos profesionales del local, ambiente, eventos pasados y momentos destacados. Fundamental para transmitir la experiencia que ofreces."
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Optimización SEO local avanzada",
      description: "Configuración para Google Maps y Google Business Profile. Aparece cuando busquen locales de ocio cerca con toda tu información actualizada."
    },
    {
      icon: <FaCalendarAlt />,
      title: "Sistema de reserva de mesas",
      description: "Formulario para reservas de mesas VIP, cumpleaños o eventos especiales. Optimiza la gestión de reservas y asegura ingresos anticipados."
    },
    {
      icon: <FaSearch />,
      title: "SEO específico para ocio nocturno",
      description: "Posicionamiento para términos como 'discoteca en [tu zona]' o tus estilos musicales. Optimización de contenidos para atraer a tu público objetivo."
    }
  ];
  
  // Planes de precios estandarizados
  const plans = [
    {
      title: 'Web Básica',
      price: 200,
      period: 'pago único',
      description: 'Para locales pequeños o que quieren iniciar su presencia digital profesional.',
      features: [
        { text: 'Hasta 5 páginas (inicio, servicios, sobre ti, contacto, blog)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=discoteca-basica',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más solicitada por discotecas. Equilibrio perfecto entre precio y funcionalidades para promocionar eventos.',
      features: [
        { text: 'Hasta 10 páginas (más secciones y servicios)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      isPopular: true,
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=discoteca-profesional',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Avanzada',
      price: 400,
      period: 'pago único',
      description: 'Para locales de ocio nocturno que quieren destacar con más funcionalidades y mejor posicionamiento.',
      features: [
        { text: 'Hasta 15 páginas (contenido extenso y detallado)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: true },
        { text: 'Ficha de Google My Business', included: true },
        { text: 'Email Corporativo 1GB', included: true },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=discoteca-avanzada',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Análisis y planificación",
      description: "Estudiamos tu local, estilo, público objetivo y eventos. Planificamos una web que transmita el ambiente único y la propuesta de valor de tu discoteca.",
      icon: <FaUsers />
    },
    {
      number: 2,
      title: "Diseño y desarrollo",
      description: "Creamos una web con diseño impactante y moderno. Implementamos todas las secciones necesarias para mostrar eventos, imágenes y toda la información relevante.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y posicionamiento",
      description: "Publicamos tu web, te formamos en su uso y configuramos estrategias SEO local para que te encuentren los clientes potenciales de tu zona.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño específico para discotecas",
      us: true,
      others: false
    },
    {
      label: "Optimización SEO local incluida",
      us: true,
      others: false
    },
    {
      label: "Galería multimedia optimizada",
      us: true,
      others: false
    },
    {
      label: "Sistema fácil de actualización de eventos",
      us: true,
      others: false
    },
    {
      label: "Compatibilidad con sistemas de reserva",
      us: true,
      others: false
    },
    {
      label: "Formación en gestión de contenidos",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Siempre pensamos que con Instagram era suficiente, pero nuestra web ha llevado la promoción de eventos a otro nivel. Ahora podemos mostrar toda la programación del mes, con información detallada de cada fiesta y DJ. Las reservas de mesas han aumentado un 40% desde que añadimos el formulario en la web, y muchos clientes nuevos nos comentan que decidieron venir después de ver las fotos y vídeos en nuestra página. Además, los eventos especiales se llenan mucho más rápido desde que podemos promocionarlos con anticipación en un espacio propio. La inversión se recuperó en menos de un mes con el aumento de asistencia a nuestras fiestas temáticas.",
    author: "Carlos Mendoza",
    position: "Propietario",
    company: "Sala Metropolis",
    avatar: "/servicios/testimonios/discoteca.webp"
  };
  
  const founderMessage = "En el sector del ocio nocturno, la experiencia visual lo es todo. Diseñamos webs para discotecas que transmiten el ambiente único de cada local, mostrando su identidad, programación y eventos especiales. El contenido multimedia de calidad es la clave para generar expectativa entre el público objetivo, convirtiendo visitantes digitales en asistentes reales a los eventos.";
  
  // FAQs específicas para web de discotecas
  const faqs = [
    {
      question: "¿Por qué necesito una web profesional para mi discoteca?",
      answer: "Una web profesional es fundamental para locales de ocio nocturno por diversos motivos estratégicos: 1) El 76% de los jóvenes entre 18-35 años buscan información online antes de decidir dónde salir de fiesta; 2) Te permite mostrar el ambiente y estilo único de tu local con contenido multimedia de alta calidad; 3) Facilita la promoción anticipada de eventos especiales, DJs invitados y fiestas temáticas, generando expectación; 4) Te posiciona en búsquedas locales como 'discotecas en [tu zona]', fundamental para captar nuevos clientes; 5) Permite implementar sistemas de reserva de mesas VIP, lista de invitados o venta anticipada de entradas; 6) Complementa y potencia tu presencia en redes sociales, ofreciendo información más completa y permanente; 7) Mejora tu imagen de marca y profesionalidad frente a la competencia. Según estudios del sector, los locales de ocio nocturno con presencia web profesional reportan un aumento promedio del 25-30% en asistencia a eventos promocionados, especialmente en noches entre semana o eventos especiales.",
      category: "Beneficios"
    },
    {
      question: "¿Cómo se mostrarán los eventos en la web?",
      answer: "Los eventos se presentarán de forma atractiva y funcional para maximizar el impacto: 1) Calendario visual destacado en la página principal, mostrando próximos eventos y permitiendo navegación por fechas; 2) Página individual para eventos especiales o DJs destacados, con información detallada, imágenes, horarios y precios; 3) Sistema de categorización por tipo de evento (sesiones regulares, fiestas temáticas, DJs invitados, etc.); 4) Galería multimedia asociada a cada evento o tipo de noche; 5) Botones de call-to-action para reserva de mesa o compra de entrada si corresponde; 6) Enlaces a eventos en redes sociales para amplificar la promoción; 7) Sección de eventos pasados con fotos y vídeos para mostrar el éxito de noches anteriores. Implementaremos un sistema intuitivo de administración para que puedas actualizar fácilmente la programación, añadir nuevos eventos o modificar detalles sin necesidad de conocimientos técnicos. También te formaremos en la optimización de imágenes y textos para maximizar el impacto de cada publicación.",
      category: "Contenidos"
    },
    {
      question: "¿Incluís un sistema de reservas o venta de entradas?",
      answer: "Los sistemas de reservas o venta de entradas no están incluidos en los precios base y se presupuestan por separado según tus necesidades: 1) Sistema básico de solicitud de reservas (desde 120€) - Formulario avanzado donde el cliente especifica fecha, número de personas, tipo de mesa y ocasión, recibiendo tú una notificación para confirmar; 2) Sistema intermedio con pago de reserva (desde 250€) - Permite al cliente abonar una señal para confirmar la reserva, con integración de pasarela de pago segura; 3) Sistema avanzado de venta de entradas (desde 400€) - Plataforma completa para venta anticipada de entradas con gestión de aforo, generación de códigos QR, y sistema de validación. Estos sistemas son complementos opcionales a la web que requieren configuración específica según tu modelo de negocio y sistema de gestión interna. También podemos integrar plataformas como Fever, Xceed o tu sistema actual si ya utilizas alguno. El presupuesto exacto se determina tras analizar tus necesidades específicas, volumen de reservas/ventas y nivel de automatización requerido.",
      category: "Funcionalidades"
    },
    {
      question: "¿Cuántas páginas incluye cada plan?",
      answer: "Cada plan incluye un número limitado de páginas para mantener la relación calidad-precio: 1) El plan Básico (200€) incluye hasta 5 páginas principales: inicio, eventos, galería, información/horarios y contacto; 2) El plan Profesional (300€) permite entre 5-10 páginas, añadiendo secciones como diferentes ambientes/salas, promociones recurrentes, DJs residentes, reserva de mesas, cumpleaños/eventos privados o sección de noticias; 3) El plan Premium (400€) permite entre 10-15 páginas, pudiendo incluir páginas específicas para cada tipo de evento recurrente, historia del local, equipo, blog de actualidad, música, colaboraciones, etc. Si necesitas más páginas de las incluidas en tu plan, tienen un coste adicional de 40€ por página. Para webs realmente extensas con más de 15 páginas o múltiples secciones especiales, recomendamos solicitar un presupuesto personalizado. La experiencia demuestra que para la mayoría de discotecas y salas, el plan Profesional ofrece el equilibrio perfecto entre inversión y funcionalidades necesarias.",
      category: "Planes"
    },
    {
      question: "¿Qué fotos y vídeos utilizaréis en la web?",
      answer: "El contenido multimedia es absolutamente crucial para una web de discoteca, ya que debe transmitir el ambiente y la experiencia única de tu local. Tienes estas opciones: 1) Material propio: Si dispones de fotografías y vídeos profesionales de eventos pasados, ambientes del local y público disfrutando, los optimizaremos y utilizaremos como base principal; 2) Sesión fotográfica profesional: Podemos recomendarte fotógrafos especializados en locales de ocio nocturno (presupuesto aproximado: 250-350€ por sesión completa); 3) Producción audiovisual: Para vídeos promocionales de alta calidad podemos conectarte con productoras especializadas (presupuestos personalizados); 4) Imágenes complementarias: Para secciones generales podemos utilizar algunas imágenes de stock de alta calidad. Es importante mostrar principalmente: el local en pleno funcionamiento con buen ambiente, detalles de decoración e iluminación, cabina/DJs en acción, y público disfrutando (siempre respetando derechos de imagen). Te asesoraremos sobre los tipos de contenido multimedia más efectivos para cada sección de la web y cómo crear un banco de imágenes potente para futuras actualizaciones.",
      category: "Contenidos"
    },
    {
      question: "¿Cómo funcionará el mantenimiento de la web?",
      answer: "El mantenimiento mensual de 20€ incluye servicios esenciales para el funcionamiento óptimo de tu web: 1) Alojamiento en servidores de alta velocidad, optimizados para cargar rápidamente contenido multimedia; 2) Renovación anual del dominio; 3) Certificado de seguridad SSL; 4) Copias de seguridad diarias; 5) Actualizaciones de seguridad y del sistema; 6) Soporte técnico por email y teléfono; 7) Pequeñas modificaciones de contenido (hasta 30 minutos mensuales); 8) Monitorización de rendimiento. Te proporcionaremos acceso a un panel intuitivo donde podrás actualizar eventos, añadir fotos/vídeos a la galería o modificar promociones. Para discotecas y locales de ocio, es especialmente útil poder actualizar regularmente el calendario de eventos y añadir contenido multimedia después de fiestas destacadas. El mantenimiento es obligatorio para garantizar el correcto funcionamiento de la web, asegurar la renovación del dominio y el alojamiento seguro de los contenidos. Si contratas un sistema de reservas o venta de entradas, este podría tener un coste de mantenimiento adicional según su complejidad (desde 10€/mes adicionales).",
      category: "Mantenimiento"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para discotecas
      pageTitle="Web para Discotecas desde 200€ | Promociona Eventos y Reservas Online"
      pageDescription="Diseño web especializado para discotecas y locales de ocio nocturno. Promociona eventos, muestra tu ambiente y gestiona reservas online. Optimizada para atraer más público."
      pageKeywords="página web barata discoteca, web para discotecas, diseño web ocio nocturno, página web sala de fiestas, web discoteca económica"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-discoteca"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para discotecas desde 200€ (promociona eventos y aumenta la asistencia)"
      heroSubtitle="Diseño web profesional para discotecas y locales de ocio nocturno. Muestra eventos, ambiente y promociones. Optimizada para atraer más público a tus fiestas."
      heroImage="/servicios/tipo-cliente/hero-discoteca.webp"
      badges={['Desde 200€ (pago único)', 'Calendario de eventos', 'Optimización local', 'Mantenimiento 20€/mes']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para tu página web de discoteca"
      pricingSubtitle="Elige el plan que mejor se adapte a tu local. Todos incluyen soporte técnico y mantenimiento por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestra web es ideal para discotecas?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <>
          <FounderInsight 
            insightText={founderMessage}
            founderName="Jaime Vela"
            founderTitle="Co-fundador y Director de Marketing"
            avatarSrc="/sobre nosotros/foto-jaime.webp"
          />
          
          <div style={{ 
            textAlign: 'center', 
            maxWidth: '800px', 
            margin: '3rem auto',
            padding: '2rem',
            background: '#f8f9fa',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}>
            <h3 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>¿Necesitas servicios adicionales?</h3>
            <p style={{ marginBottom: '1.5rem', color: 'var(--gray)' }}>
              Visita nuestra página de precios para conocer todas nuestras opciones de servicios sueltos, 
              paquetes personalizados y características adicionales para tu web.
            </p>
            <Button 
              as="a" 
              href="/precios" 
              variant="outline"
              size="medium"
            >
              Ver todos los precios
            </Button>
          </div>
        </>
      }
      
      processTitle="Creamos tu web en 3 sencillos pasos"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué elegirnos para tu web de discoteca?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="Ventajas de una web profesional para tu discoteca"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para discotecas"
      faqCategories={["Beneficios", "Contenidos", "Funcionalidades", "Planes", "Mantenimiento"]}
      faqs={faqs}
      
      ctaTitle="Impulsa tu discoteca con presencia online profesional"
      ctaDescription="Una inversión inteligente que aumentará la asistencia a tus eventos, permitirá promocionar fiestas especiales y diferenciará tu local de la competencia. Recupera la inversión rápidamente."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebDiscotecaPage; 

